export function StatCard({ label, value, sub, icon: Icon }) {
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6" data-testid={`stat-${(label || "").toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="flex items-center justify-between">
        <span className="text-xs tracking-[0.15em] uppercase font-bold text-slate-500">{label}</span>
        {Icon && <Icon size={18} className="text-blue-400" />}
      </div>
      <div className="mt-4 font-display text-4xl font-medium text-white tracking-tight">{value}</div>
      {sub && <div className="mt-1 text-xs text-slate-500">{sub}</div>}
    </div>
  );
}

const STATUS_STYLES = {
  active: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  Live: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  accepted: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30",
  pending: "bg-amber-500/15 text-amber-300 border-amber-500/30",
  Draft: "bg-slate-500/15 text-slate-300 border-slate-500/30",
  "In Review": "bg-blue-500/15 text-blue-300 border-blue-500/30",
  suspended: "bg-red-500/15 text-red-300 border-red-500/30",
  Rejected: "bg-red-500/15 text-red-300 border-red-500/30",
};

export function StatusPill({ status }) {
  const cls = STATUS_STYLES[status] || "bg-white/10 text-slate-300 border-white/15";
  return (
    <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium capitalize ${cls}`}>
      {status}
    </span>
  );
}

export function EmptyState({ title, desc }) {
  return (
    <div className="rounded-2xl border border-dashed border-white/10 py-16 text-center">
      <div className="font-display text-lg text-white">{title}</div>
      {desc && <div className="mt-2 text-sm text-slate-500 max-w-sm mx-auto">{desc}</div>}
    </div>
  );
}

export function TableWrap({ children }) {
  return (
    <div className="rounded-2xl border border-white/10 overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse min-w-[600px]">{children}</table>
      </div>
    </div>
  );
}

export const th = "py-4 px-5 border-b border-white/10 text-xs font-bold uppercase tracking-wider text-slate-500";
export const td = "py-4 px-5 border-b border-white/5 text-sm text-slate-300 align-middle";

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "—";
  }
}
